import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  LastReadMessageModel,
  MessageSearchModel,
  ReadMessagesModel,
  RequestMessageModel,
  RequestMessageSendModel,
  SupplierOfferMessageModel, SupplierOfferMessageSendModel,
  SupplierOfferModel
} from 'src/common';
import {SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/SupplierOffer`;

@Injectable()
export class SupplierOfferService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<SupplierOfferModel>> {
      return this.http.post<SearchResultModel<SupplierOfferModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<any[]> {
	return this.http.get<SupplierOfferModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<SupplierOfferModel> {
    return this.http.get<SupplierOfferModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete?supplierOfferId=${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/SaveSupplierOffer`, model).toPromise();
  }


  // custom-start

  changeStatus(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/ChangeStatus`, model).toPromise();
  }

  getMessages(id: number, model: MessageSearchModel): Promise<SupplierOfferMessageModel[]> {
    return this.http.post<SupplierOfferMessageModel[]>(`${environment.apiUrl}/SupplierOffer/MessagesSearch/${id}`, model).toPromise();
  }

  sendMessage(model: SupplierOfferMessageSendModel): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/SendMessage`, model).toPromise();
  }

  saveReadMessages(model: ReadMessagesModel): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/SaveReadMessages`, model).toPromise();
  }

  getLastReadMessage(id: number): Promise<LastReadMessageModel> {
    return this.http.get<LastReadMessageModel>(`${localApiUrl}/GetLastReadMessage/${id}`).toPromise();
  }

  // custom-end

  init(requestRoundSupplierId): Promise<void> {
    return this.http.get<void>(`${localApiUrl}/SupplierOfferInitialInsert?requestRoundSupplierId=${requestRoundSupplierId}`).toPromise();
  }
}



